import script from "./AdminLocationImages.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminLocationImages.vue?vue&type=script&setup=true&lang=js"

import "./AdminLocationImages.vue?vue&type=style&index=0&id=bc72d060&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc72d060"]])

export default __exports__